export const AiActivityEmptyStateTestIds = {
  ACTION_BUTTON: 'empty-state.action-button',
};
